/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_NowInputs */

const en_time_now = /** @type {(inputs: Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`now`)
};

const de_time_now = /** @type {(inputs: Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jetzt`)
};

/**
* | output |
* | --- |
* | "now" |
*
* @param {Time_NowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const time_now = /** @type {((inputs?: Time_NowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_NowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_time_now(inputs)
	return en_time_now(inputs)
});